module.exports = __webpack_public_path__ + "img/arena-703.f01fb9d4.png";